import React from 'react';

// The line and its segments are found by class: they stay in the DOM to be
// measured while the verdict on them is being made.
export const FACTS_CLASS = 'cardIdentity__facts';
export const factClass = (key) => `cardIdentity__fact--${key}`;

// What a crowded line gives up, in order. The lead and the item count stay.
export const SHED_ORDER = ['age', 'needed', 'reviewed'];

/**
 * Sheds facts until the line holds one line, and drops the line itself when
 * even the count won't fit. Measures from nothing-shed each time, so a verdict
 * never depends on the one before it, and reports through `data-shed`.
 */
export default function useFactsFit(signature) {
  const stackRef = React.useRef(null);
  const [shed, setShed] = React.useState('');

  React.useLayoutEffect(() => {
    const stack = stackRef.current;
    if (!stack) return undefined;
    const decide = () => {
      const line = stack.querySelector(`.${FACTS_CLASS}`);
      if (!line) return;
      const overflows = () => line.scrollWidth > line.clientWidth + 1;
      const dropped = [];
      stack.dataset.shed = '';
      while (overflows() && dropped.length < SHED_ORDER.length) {
        dropped.push(SHED_ORDER[dropped.length]);
        stack.dataset.shed = dropped.join(' ');
      }
      if (overflows()) dropped.push('all');
      stack.dataset.shed = dropped.join(' ');
      setShed(stack.dataset.shed);
    };
    decide();
    const observer = new ResizeObserver(decide);
    observer.observe(stack);
    return () => observer.disconnect();
  }, [signature]);

  return { stackRef, shed };
}
